module.exports = __webpack_public_path__ + "static/Light-Orange-35f1300b5218c4a7f745c3ca299db8fd.png";